import { render } from "./ExecutionHistoricCard.vue?vue&type=template&id=6b8fb646"
import script from "./ExecutionHistoricCard.vue?vue&type=script&lang=js"
export * from "./ExecutionHistoricCard.vue?vue&type=script&lang=js"
script.render = render

export default script